import { StyledCard, StyledTypography } from "../../assets/css/styledComponent";
import React from "react";
import { useTheme, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { Container } from "@mui/system";
import categoryBusinessCardClass from "./categoryBusinessCard.styles";
import BusinessBookingTypeList from "../../components/business/bookingType/businessBookingTypeList";
import officePlaceHolderImage from "../../assets/images/business-image-placeholder.png";
import BusinessAddressLink from "../../util/google/businessAddressLink";

const CategoryBusinessCard = (props: any) => {
  const theme = useTheme();
  const styles = categoryBusinessCardClass(theme);

  return (
    <Container maxWidth="lg" sx={styles.root}>
      <StyledCard
        sx={{
          maxWidth: "100%",
          boxShadow: theme.shadows[3],
          borderRadius: "10px",
        }}
      >
        {/* Main Flexbox Container */}
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ gap: { xs: "0rem", md: "2rem" } }} // Spacing between image and text
        >
          {/* Image on the left for large screens and part of the top row on small */}
          <Box component={Link} to={`/${props.business.url}`}>
            <Box
              component="img"
              src={props.business.images[0]?.url ?? officePlaceHolderImage}
              alt={props.business.name}
              sx={{
                width: { xs: "80%", md: "300px" }, // 80% width on small screens, fixed on large
                minWidth: "160px",
                height: "auto",
                objectFit: "cover",
                borderRadius: "10px",
                marginRight: { xs: 1, md: 1 }, // Ensure no margin on small screens
              }}
            />
          </Box>

          {/* Right side content on large screens, part of the row on small */}
          <Box sx={{ paddingTop: "2px" }}>
            <Box>
              <Link
                to={`/${props.business.url}`}
                style={{ textDecoration: "none" }}
              >
                <StyledTypography>{props.business.name}</StyledTypography>
              </Link>
              <StyledTypography
                variant="body2"
                color="textSecondary"
                sx={{ mb: 1 }}
              >
                <BusinessAddressLink address={props.business.address} />
              </StyledTypography>
              {/* // TODO */}
              {/* <Box
                display="flex"
                alignItems="center"
                sx={{ marginBottom: "1rem" }}
              >
                <Rating value={5} readOnly />
                <StyledTypography
                  variant="body2"
                  color="textSecondary"
                  sx={{ ml: 1 }}
                >
                  5.0
                </StyledTypography>
              </Box> */}
            </Box>

            {/* BookingTypeList visible for large screens on the right */}
            <Box
              display={{ xs: "none", md: "block" }} // Hidden on small screens, visible on large
            >
              <BusinessBookingTypeList
                business={props.business}
                url={props?.business?.url ?? props?.url}
              />
            </Box>
          </Box>
        </Box>

        {/* For small screens, BookingTypeList appears underneath */}
        <Box
          display={{ xs: "block", md: "none" }} // Visible only on small screens
          sx={{ mt: { xs: "1rem", md: 0 } }}
        >
          <BusinessBookingTypeList
            business={props.business}
            url={props?.business?.url ?? props?.url}
          />
        </Box>
      </StyledCard>
    </Container>
  );
};

export default CategoryBusinessCard;
